/**
 * Client-side CSV file pick validation and sample download. Shared across all CSV import
 * pages (finance, assets, vendors, programs, shield care, etc.).
 */

/**
 * Escape a single CSV field (RFC-style quoting when needed).
 * @param {unknown} val
 * @returns {string}
 */
export function escapeCsvCell(val) {
  const s = val == null || val === "" ? "" : String(val);
  if (s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Validate picked file is CSV. If invalid, calls `onInvalidFile` (if provided).
 * @param {React.ChangeEvent<HTMLInputElement>} event
 * @param {(file: File) => void} importFromCsv
 * @param {(message: string) => void} [onInvalidFile]
 */
export function attachValidatedCsvFileImport(event, importFromCsv, onInvalidFile) {
  const file = event.target.files[0];
  if (file) {
    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      if (typeof onInvalidFile === "function") onInvalidFile("Please select a CSV file");
      event.target.value = "";
      return;
    }
    importFromCsv(file);
    event.target.value = "";
  }
}

/**
 * @param {string} filename
 * @param {string[]} lines - each full line (no automatic line endings added between)
 */
export function downloadCsvTextFile(filename, lines) {
  const csv = lines.join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Download pre-built CSV text (e.g. from an API that returns a full document).
 * @param {string} filename
 * @param {string} csvText - full file body; line endings preserved
 */
export function downloadCsvTextFromString(filename, csvText) {
  const blob = new Blob([csvText != null ? String(csvText) : ""], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
